import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ClientesService } from '../../../services/Clientes.service';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Helper } from '../../../helpers/helper';
import { AlertasModales } from '../../../helpers/alertasModales';
@Component({
  selector: 'app-comentario-cliente',
  templateUrl: './comentario-cliente.component.html',
  styleUrls: ['./comentario-cliente.component.css']
})
export class ComentarioClienteComponent implements OnInit {
  @Input() ID_CLIENTE;
  @Input() modals: AlertasModales;
  form: FormGroup;
  dateNow = new Date(this.helper.getDate());
  loading = false;
  constructor(
    public activeModal: NgbActiveModal,
    private clienteService: ClientesService,
    private empleadoService: EmpleadosServicio,
    private helper: Helper) {
    this.initForm();
  }

  ngOnInit() {
    this.form.get('recordatorio').valueChanges
    .subscribe(res => {
      if (res) {
        this.form.get('fecha_recordatorio').setValidators(Validators.required);
        this.form.get('tiempo').setValidators(Validators.required);
        this.form.updateValueAndValidity();
      } else {
        this.form.get('fecha_recordatorio').clearValidators();
        this.form.get('tiempo').clearValidators();
        this.form.updateValueAndValidity();
      }
    });
  }

  private initForm(): void {
    this.form = new FormGroup({
      comentario: new FormControl('', Validators.required),
      recordatorio: new FormControl(false),
      fecha_recordatorio: new FormControl({
        year: this.dateNow.getFullYear(),
        month: this.dateNow.getMonth() + 1,
        day: this.dateNow.getDate()
      }),
      tiempo: new FormControl({
        hour: this.dateNow.getHours(),
        minute: this.dateNow.getMinutes()
      })
    });
  }

  crearNota() {
    if (this.form.valid && !this.loading) {

      let fecha = '';
      if (this.form.get('recordatorio').value) {
        const d = this.form.get('fecha_recordatorio').value;
        const t = this.form.get('tiempo').value;
        // tslint:disable-next-line:max-line-length
        fecha = `${d.year}-${(d.month < 10 ? '0' + d.month : d.month)}-${d.day < 10 ? '0' + d.day : d.day } ${(t.hour < 10 ? '0' + t.hour : t.hour)}:${(t.minute < 10 ? '0' + t.minute : t.minute)}`;
      }
      const data = {
        ID_CLIENTE: this.ID_CLIENTE,
        ID_EMPLEADO: this.empleadoService.datosEmpleado.ID_EMPLEADO,
        comentario: this.form.value.comentario,
        recordar: this.form.value.recordatorio,
        fecha_recordatorio: fecha
      };
      this.loading = true;
      this.clienteService.registrarNotaCliente(data).subscribe(res => {
        this.loading = false;
        if (res) {
          this.activeModal.close(res);
        }
      }, err => {
        this.loading = false;
        if (err.status == 403) {
          this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
          'red',
          'modern',
          false,
          'fa fa-file-text');
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/modals/comentario-cliente/comentario-cliente.component.ts